/**
 * Response normalization helpers
 * Centralizes defensive API response unpacking
 */

export { extractErrorMessage } from '@shared/utils';

/**
 * Extract a list from API response data, trying keys in order.
 * Falls back to array check on the data itself.
 */
export const extractList = (data, ...keys) => {
  if (!data) return [];
  for (const key of keys) {
    if (Array.isArray(data[key])) return data[key];
  }
  if (Array.isArray(data)) return data;
  return [];
};

/**
 * Extract an object from API response data, trying keys in order.
 * Falls back to data itself if it's a plain object.
 */
export const extractObject = (data, ...keys) => {
  if (!data) return {};
  for (const key of keys) {
    if (data[key] && typeof data[key] === 'object' && !Array.isArray(data[key])) {
      return data[key];
    }
  }
  return typeof data === 'object' && !Array.isArray(data) ? data : {};
};

/**
 * Extract total count from paginated API response.
 */
export const extractTotal = (data) => {
  if (!data) return 0;
  return data.total ?? data.count ?? 0;
};

